import { useEffect, useRef, useState } from "react";
import Header from "../../../components/header";
import {
  MarketingBanner,
  MarketingButton,
  MarketingContentWrapper,
  MarketingInfo,
  MarketingItemTitle,
  MarketingItemWrapper,
  MarketingWrapper,
} from "./style";
import {
  getMarketingProducts,
  MarketingProductDto,
  MarketingProductType,
} from "../../../api/marketing";
import MarketingRequestPopup from "./components/request";

const Marketing = () => {
  const [showHeader, setShowHeader] = useState(true);
  const bannerRef = useRef<HTMLDivElement>(null);
  const [list, setList] = useState<MarketingProductDto[]>([]);
  const [popup, setPopup] = useState(false);
  const [product, setProduct] = useState<MarketingProductDto>();
  const [productId, setProductId] = useState(0);
  const [productType, setProductType] = useState<MarketingProductType>(
    MarketingProductType.QUANTITY
  );

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.4, // 10% 보일 때 트리거
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  const getData = async () => {
    const res = await getMarketingProducts();
    setList(res);
  };

  useEffect(() => {
    getData();
  }, []);

  const requestProduct = (data: MarketingProductDto) => {
    setProduct(data);
    setPopup(true);
  };

  return (
    <MarketingWrapper>
      {popup && <MarketingRequestPopup setPopup={setPopup} product={product} />}
      <Header title="마케팅 광고 상품" show={showHeader} />
      <MarketingBanner ref={bannerRef}>
        <img src="/image-web/marketing/banner.png" alt="banner" />
        <div className="text">
          <div>
            함께 성장하는 러너러너
            <br />
            많은 고객을 유입해보세요
          </div>
          <div className="border">-</div>
        </div>
      </MarketingBanner>
      <MarketingContentWrapper>
        {list.map((item, index) => (
          <MarketingItemWrapper key={index}>
            <MarketingItemTitle>
              {item.price?.toLocaleString()}원<span>/</span>
              <span>{item.count}</span>
            </MarketingItemTitle>
            <MarketingInfo>
              <div>• {item.name}</div>
            </MarketingInfo>
            <MarketingButton onClick={() => requestProduct(item)}>
              선택
            </MarketingButton>
          </MarketingItemWrapper>
        ))}
      </MarketingContentWrapper>
    </MarketingWrapper>
  );
};

export default Marketing;
